/// <reference path="index.d.ts" />
import * as React from 'react'
import { resetUrl } from '../../common/reset-image';

interface Props {
  imageZoom: ZoomProps
  url: string
}

interface PosProps {
  x: number
  y: number
}

const { useState } = React;

export default function ImageDrag ( props: Props ) {
  const { url,imageZoom } = props;

  const [position,setPosition] = useState<PosProps>( {
    x: 0,
    y: 0
  } )

  const moveImage = ( e: any ) => {
    const { x,y } = position;
    e.preventDefault();

    const disx = e.pageX - x;
    const disy = e.pageY - y;

    document.onmousemove = ( ev: any ) => {
      setPosition( {
        x: ev.pageX - disx,
        y: ev.pageY - disy,
      } );
    };

    document.onmouseup = () => {
      document.onmousemove = null;
      document.onmousedown = null;
    };
  };

  const renderTransform = (): any => {
    const style = {
      width: '100%',
      objectFit: 'contain',
      cursor: 'all-scroll',
      maxHeight: '90vh',
    }
    if ( imageZoom && imageZoom.scale > 1 ) {
      return {
        transform: `scale(${imageZoom.scale}) translate(${position.x}px, ${position.y}px)`,
        ...style
      }
    } else {
      return {
        transform: 'scale(1) translate(0px, 0px)',
        transition: 'all 0.3s',
        ...style
      }
    }
  }


  return (
    <img loading='lazy' src={imageZoom && imageZoom.scale > 1 ? url : resetUrl( url,'960' )} onMouseDown={moveImage} style={renderTransform()} />
  )
}
